import Vue from 'vue'
import Vuex from 'vuex'
import account from './account'
import auth from './auth/index'
import basket from './basket'
import confirmations from './confirmations'
import comments from './comments'
import notifications from './notifications/index.js'
import offers from './offers/index'
import orders from './orders/index'
import state from './state'
import localModal from './localModal'
import cookieConsent from './cookieConsent'
import messages from './messages'
import basketImport from './basketImport'
import lightbox from './lightbox'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    account,
    auth,
    basket,
    confirmations,
    comments,
    notifications,
    offers,
    orders,
    localModal,
    messages,
    cookieConsent,
    basketImport,
    lightbox,
  },
})
